import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * Shared loading state for the customer onboarding flow.
 */
@Injectable()
export class CustomerOnboardingLoadingService {
  private readonly isLoadingSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  /**
   * Emits `true` while a customer onboarding operation is in progress.
   * Only emits when the value changes.
   */
  readonly isLoading$: Observable<boolean> = this.isLoadingSubject$.asObservable().pipe(distinctUntilChanged());

  /**
   * Updates the global customer onboarding loading flag.
   *
   * @param isLoading - whether a loading indicator should be shown
   */
  updateLoadingState(isLoading: boolean): void {
    this.isLoadingSubject$.next(isLoading);
  }
}
